//TODO:参考のためのみ保持
/** 後方支援システム権限コード */
export const DISASTER_OPERATION_AUTH_CODE = {
  /** ダッシュボード画面 */
  dashboard: 100,
  /** 発行管理画面 */
  certificateManagement: 101,
  /** 調査地域画面 */
  inspectionPlan: 102,
  /** 調査員画面 */
  inspectionMembers: 103,
  /** 調査班画面 */
  inspectionTeams: 104,
  /** 調査予定画面 */
  inspectionDailyPlan: 105,
  /** 調査状況画面 */
  inspectionMonitor: 106,
  /** 発行承認画面 */
  inspectionResultApproval: 107,
  /** 管理者メニュー画面 */
  administratorMenu: 108
} as const

/** 調査アプリ権限コード */
export const DISASTER_INV_AUTH_CODE = {
  /** 調査アプリ */
  invApp: 200,
  /** 調査員登録画面 */
  inspectionMemberResist: 201
} as const

/** システム連携オプション（ETL）システム権限コード */
export const DISASTER_PREPROCESS_AUTH_CODE = {
  governmentManagement: 300
} as const

/** 台帳システム権限コード */
export const DISASTER_SUPPORT_AUTH_CODE = {
  /** メニュー画面 */
  menu: 501,
  certificateIssue: 501,
  certificateList: 501,
  supportApplicationList: 501,
  supportStatus: 501,
  supportConfig: 501,
  supportProgramRegister: 501,
  supportStatusDetail: 501
}

/** 応急危険度判定の機能 */
export const EMERGENCY_SCOPE = {
  riskAssessment: 'riskAssessment'
} as const
export type EmergencyScope = (typeof EMERGENCY_SCOPE)[keyof typeof EMERGENCY_SCOPE]

/** アクションタイプ */
export const ACTION_TYPE = {
  read: 'R',
  write: 'W',
  manage: 'M'
} as const
export type ActionType = (typeof ACTION_TYPE)[keyof typeof ACTION_TYPE]

/** 応急危険度判定の権限 */
export interface EmergencyAuthority {
  scope: EmergencyScope
  actions: ActionType[]
}
